import { createApi } from '@reduxjs/toolkit/query/react';

import { WORKLIST_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const worklistApi = createApi({
    baseQuery: getBaseQuery(WORKLIST_API_URL),
    refetchOnMountOrArgChange: true,
    reducerPath: 'worklistApi',
    endpoints: (build) => ({
        postClearWorklistTasks: build.mutation<void, { taskIds: string[] }>({
            query: ({ taskIds }) => ({
                url: 'tasks/clear',
                method: 'POST',
                body: taskIds,
            }),
            transformErrorResponse: handleRTKQueryError('An error occurred clearing tasks.'),
        }),
        postRebillAttestation: build.mutation<void, { taskId: string }>({
            query: ({ taskId }) => ({
                url: `tasks/attest/${taskId}`,
                method: 'POST',
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred submitting attestation.',
            ),
        }),
        postUnableToCompleteTask: build.mutation<void, { taskId: string; reason: string }>({
            query: ({ taskId, reason }) => ({
                url: `tasks/move/${taskId}`,
                method: 'POST',
                body: { reason },
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred confirming task as unable to complete.',
            ),
        }),
        postConfirmNeedsByDateTasks: build.mutation<void, { referralId: string }>({
            query: ({ referralId }) => ({
                url: `tasks/confirm_needs_by_date/${referralId}`,
                method: 'POST',
            }),
            transformErrorResponse: handleRTKQueryError(
                'Unable to update needs by date. Please try again.',
            ),
        }),
    }),
});

export const {
    usePostClearWorklistTasksMutation,
    usePostRebillAttestationMutation,
    usePostUnableToCompleteTaskMutation,
    usePostConfirmNeedsByDateTasksMutation,
} = worklistApi;
